import { inlineToolbarTabs } from '../../inline';
import { BlockToolbarComponent } from './components';
export var videoBlock = {
  blockToolbarComponent: BlockToolbarComponent,
  inlineToolbarTabs: inlineToolbarTabs,
  isEditable: true
};